import {Component, EventEmitter, Input, OnDestroy, Output, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ProfileService} from '../services/profile.service';

declare const toastr: any;

@Component({
    selector: 'change-password',
    templateUrl: 'change-password.component.html',
    styleUrls: ['change-password.component.scss']
})
export class ChangePasswordComponent implements OnDestroy{
    @Output() onToggleShow: EventEmitter<any> = new EventEmitter();
    @Input() data;
    @ViewChild('form') form;

    isActiveFirst: boolean = false;
    isActiveSecond: boolean = false;

    lengthPassed: boolean = false;
    upperPassed: boolean = false;
    lowerPassed: boolean = false;
    numberPassed: boolean = false;

    isEqualPasswords: boolean = false;
    isRulesPassed: boolean = false;

    constructor(public profile: ProfileService) {
    }

    toggleChangePasswordForm(form: NgForm) {
        form.resetForm();
        this.onToggleShow.emit();
    }

    onChangePasswordSubmit(form: NgForm) {
        if (form.invalid) return;
        if (!this.isRulesPassed) return toastr.warning('All rules must be respected!');
        if (!this.isEqualPasswords) return toastr.warning('The password fields must match!');

        this.profile.updatePassword(this.data, form);
    }

    onFocusInput(event) {
        this.validate(event);

        if (event.target.id === 'user_password_first') {
            this.isActiveFirst = true;
            this.isActiveSecond = false;
        } else {
            this.isActiveFirst = false;
            this.isActiveSecond = true;
        }
    }

    onBlurInput() {
        this.resetRules();
        this.isActiveFirst = false;
        this.isActiveSecond = false;
    }

    validate(event) {
        this.isEqualPasswords = this.data.plainPassword.first && this.data.plainPassword.second
            && (this.data.plainPassword.first === this.data.plainPassword.second);
        event.target.value = event.target.value.trim();
        const value = event.target.value;
        this.resetRules();

        if (value.length > 5) {
            this.lengthPassed = true;
        }
        if (/[A-Z]/.test(value)) {
            this.upperPassed = true;
        }
        if (/[a-z]/.test(value)) {
            this.lowerPassed = true;
        }
        if (/[0-9]/.test(value)) {
            this.numberPassed = true;
        }

        this.isRulesPassed = this.lengthPassed && this.upperPassed && this.lowerPassed && this.numberPassed;
    }

    resetRules() {
        this.lengthPassed = false;
        this.upperPassed = false;
        this.lowerPassed = false;
        this.numberPassed = false;
    }

    ngOnDestroy(): void {
        this.form.resetForm();
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/profile/change-password/change-password.component.ts